interface ICustomButton {
    className?: string;
    title: string;
    disabled?: boolean;
    loading?: boolean;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    iconReverse?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const CustomButton = ({ className, title, onClick = () => { }, disabled = false, loading = false, Icon, iconReverse = false }: ICustomButton) => {
    return (
        <>
            {
                loading ?
                    <div
                        className={`flex items-center justify-center rounded-md min-w-40 py-2 px-4 h-15 border border-transparent text-center text-xl font-normal bg-[#D4DCDA] text-white transition-all select-none mobile:w-full mobile:min-w-0 mobile:text-base
                        ${className}
                        `}
                    >
                        로딩중...
                    </div> :
                    <button
                        className={`flex items-center justify-center gap-3 rounded-md min-w-40 h-15 border border-transparent text-center text-xl font-normal text-white transition-all cursor-pointer 
                            hover:shadow-lg hover:bg-hover 
                            disabled:cursor-not-allowed disabled:bg-[#9D9EB7] disabled:text-white select-none
                            mobile:w-full mobile:min-w-fit mobile:text-base tablet:h-10
                            ${iconReverse ? ' flex-row-reverse' : ''}
                            ${className}`}
                        type="button"
                        disabled={disabled}
                        onClick={onClick}
                    >
                        {Icon && <Icon />}
                        {title}
                    </button>

            }
        </>
    );
}

export default CustomButton;
